'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".Vpod-module_containerOuterHidden__CWfhU{display:none}.Vpod-module_container__-BiB7{padding:.5rem 0}";
var styles = {"containerOuterHidden":"Vpod-module_containerOuterHidden__CWfhU","container":"Vpod-module_container__-BiB7"};
styleInject["default"](css_248z, '28a81ffe-e278-4574-9d6d-97a2726bcfb2');

exports["default"] = styles;
